export const emptyChannelConditions = () => ({
  operator: 'AND',
  0: {
    operator: 'AND',
    0: {}
  }
})



// WEBPACK FOOTER //
// ./src/modules/settings/components/channelIncludeConditions.js